import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { StructureEditorConfig } from '@Pages/StructureEditor/StructureEditorConstants';
import StructureEditorInstance from '@Containers/StructureEditor/StructureEditorInstance';
import MarvinController from './MarvinController';

import './Marvin.custom.scss';

export default class Marvin extends PureComponent {
  constructor(props) {
    super(props);
    this.frameRef = React.createRef();
  }

  componentDidMount() {
    const { editMode, onChange, onLoaded } = this.props;
    this.instance = new MarvinController(this.frameRef.current, { editMode });
    this.instance.onChange(onChange);
    this.instance.onLoaded(onLoaded);
    StructureEditorInstance.instance = this.instance;
  }

  componentWillUnmount() {
    StructureEditorInstance.instance = undefined;
  }

  render() {
    const { className, tabIndex } = this.props;
    return (
      <section className={classnames('react-marvin-editor--wrapper', className)}>
        <iframe
          title="MarvinJS Structure Editor"
          ref={this.frameRef}
          className="e2e-marvin-editor react-marvin-editor"
          tabIndex={tabIndex}
          src={StructureEditorConfig.editor}
          frameBorder="0"
          data-hasaromaticity="false"
        />
      </section>
    );
  }
}

Marvin.defaultProps = {
  editMode: true,
  onLoaded: () => {},
  onChange: () => {},
};

Marvin.propTypes = {
  className: PropTypes.string,
  editMode: PropTypes.bool,
  tabIndex: PropTypes.string,
  onChange: PropTypes.func,
  onLoaded: PropTypes.func,
};
